import { createAction } from '@reduxjs/toolkit';

export const analyticsSSICardApplicationViewModal = createAction(
    'ANALYTICS::SSI_CARD_APPLICATION::VIEW_MODAL',
);

export const analyticsSSICardApplicationClickChangeEmployer = createAction(
    'ANALYTICS::SSI_CARD_APPLICATION::CLICK_CHANGE_EMPLOYER',
);

export const analyticsSSICardApplicationClickContinue = createAction(
    'ANALYTICS::SSI_CARD_APPLICATION::CONTINUE',
);

export const analyticsSSICardApplicationViewSplitPage = createAction(
    'ANALYTICS::SSI_CARD_APPLICATION::VIEW_SPLIT_PAGE',
);

export const analyticsSSICardApplicationClickSplitContinue = createAction(
    'ANALYTICS::SSI_CARD_APPLICATION::CLICK_SPLIT_CONTINUE',
);
